module.exports = __webpack_public_path__ + "assets/images/animations/listarobinson-animation.webp?8d8aa700";